import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, ButtonProps } from '@/components/form/baseInputs/Button';
import { ArrowUpRightIcon } from '@/components/icons/ArrowUpRightIcon';
import { useHouseholdDetailsContext } from '@/modules/household/contexts/householdDetails.context';
import { ROUTE_KEYS } from '@/navigation/constants';
import { getCompletePathFromRouteKey } from '@/navigation/navigationUtils';

export interface ViewHoldingsGroupButtonProps {
  holdingsGroupId: string;
}

export function ViewHoldingsGroupButton({
  holdingsGroupId,
}: ViewHoldingsGroupButtonProps) {
  const navigate = useNavigate();
  const { householdId } = useHouseholdDetailsContext();

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    navigate(
      getCompletePathFromRouteKey(ROUTE_KEYS.HOUSEHOLD_ENTITY_DETAILS, {
        entityId: holdingsGroupId,
        householdId: householdId!,
      })
    );
  };

  return (
    <ViewHoldingsGroupPresentationButton onClick={handleClick}>
      Overview
    </ViewHoldingsGroupPresentationButton>
  );
}

export function ViewHoldingsGroupPresentationButton(
  props: Partial<ButtonProps>
) {
  return (
    <Button
      size="xs"
      endIcon={ArrowUpRightIcon}
      variant="secondary"
      aria-label="Overview"
      {...props}
    >
      {props.children}
    </Button>
  );
}
